import DetailCompany from "../components/detailCompany/DetailCompany";

const DetailCompanyPage = () => {
  return <DetailCompany />;
};
export default DetailCompanyPage;
